import React,{useState,useEffect} from 'react';
import { Button } from 'react-bootstrap';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  BomDatatable = (props) => {

    const [t] = useTranslation();        
    const [checkTime, setCheckTime] = useState(null);
    const tableName = t('workOrder.label.bom'); 


    const clickHandler = (row) => {
        //row.target.id      
        props.modalCallback(true,row.target.id);  
       
     };

    const columns = [       
        { name: "Id", data: "id", selector: "id", omit: true},
        { name: t('article.label.article'), data: "article.name", sortable: true, selector: "article.name"},           
        { name: t('article.label.articleNumber'), data: "article.nbr", sortable: true, selector: "article.nbr"},    		            
        { name: t('workOrder.label.bomName'), data: "name", sortable: true, selector: "name"},
        { name: t('workOrder.label.alternative'), data: "nbr", sortable: true, selector: "nbr"},    		
        { name: t('general.label.description'), data: "description", sortable: true, selector: "description"}, 
        { name: t('general.button.edit'), cell:(row) => row.id ? <Button className="btn-default"  onClick={clickHandler} id={row.id} name={row.name} >{t('general.button.edit')}</Button> : "",
        ignoreRowClick: true,
        allowOverflow: true,
        button: true
        
     }          
     
    ];        


    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('article.label.article'), data: "article.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		     
        { name: t('article.label.articleNumber'), data: "article.nbr", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('workOrder.label.bomName'), data: "name", orderable: true,  searchable: true, search: {value: '',regex: false}},            
        { name: t('workOrder.label.alternative'), data: "nbr", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('general.button.edit'), data: "", searchable: false, orderable: false, search: {value: '',regex: false}}
          
    ];    
            
     const url = RestService.getBaseURL()+"workOrder/getBomList";   
     const urlExcel = RestService.getBaseURL()+"workOrder/getExcelBom";          
    
   
 
   

      useEffect(() => {      
        setCheckTime(props.checkTime);
      }, [props.checkTime])


     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={true}
                 checkTime={checkTime}
             />
           
         );
    
 
  
 };

export default BomDatatable;

